module.exports = __webpack_public_path__ + "static/media/img26.48252b4b.jpg";